<template>
  <div>
    <c-select v-if="clients.length > 1" :value="clientId" :options="clients" :disabled="isSaving" @update:value="selectClient" />
    <a href="#" v-show="$auth.check('organisation-admin')" @click="showCreate = true" :class="{'float-right': clients.length > 1}">
      + Add New Client
    </a>
    <slot name="actions"/>
    <create-client :show="showCreate" @close="showCreate = false" @created="fetchData" @newClient="setNewClient" />
  </div>
</template>

<script>
import CreateClient from '@/views/components/clients/create';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'SetClient',
  components: {
    CreateClient,
  },
  props: {
    isSaving: Boolean,
    site: Object,
  },
  data() {
    return {
      error: null,
      clients: [],
      isLoading: true,
      selectedOption: null,
      showCreate: false,
      clientId: null,
    };
  },
  mounted() {
    this.clientId = this.site?.clientId || null;
    this.fetchData();
  },
  methods: {
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
    selectClient(e) {
      this.selectedOption = e;
      const client = this.clients.find((c) => c.value === this.selectedOption);
      this.$emit('selected', client);
    },
    setNewClient(newClient) {
      // eslint-disable-next-line no-underscore-dangle
      this.clientId = newClient._id;
      // eslint-disable-next-line no-underscore-dangle
      this.selectedOption = newClient._id;
      this.$emit('selected', {
        label: newClient.name,
        // eslint-disable-next-line no-underscore-dangle
        value: newClient._id,
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .get(buildEndpoint(`clients/list/${this.$store.state.app.authenticatedUser.organisationId}`))
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.clients = response.data.data.map((client) => ({
              // eslint-disable-next-line no-underscore-dangle
              value: client._id,
              label: client.name,
            }));
            this.clients.unshift({
              value: null,
              label: 'Select a client',
            });
          }
        })
        .catch((error) => {
          this.clientError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
